<template>
  <div align="center" class="medLoader"
       v-show="!$route.meta.isAuthView && !$store.state.user.scope && !$route.meta.hideLoader">
    <mu-flexbox align="center" justify="center" style="height: 100%;width: 100%;">
      <mu-flexbox-item align="center">
        <div style="width: 160px;" class="bootLoader">
          <img width="100%" src="static/loader-gif.gif" :alt="$t('message.loadingText')"/>
          <div v-text="loadingMessage"></div>
        </div>
      </mu-flexbox-item>
    </mu-flexbox>
  </div>
</template>
<script>
  import 'gsap'
  export default {
    name: 'boot-loader',
    props: {
      loadingMessage: ""
    }
  }
</script>
<style lang="less">
  .medLoader {
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
  }

  .bootLoader {
    position: relative;
    overflow: hidden;
    padding: 7.5px;

    .logo {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1
    }
  }
</style>



// WEBPACK FOOTER //
// BootLoader.vue?0fbb96cd